// extracted by mini-css-extract-plugin
export default {"unitsContainer":"units_unitsContainer__Pf8Y7","units":"units_units__4Aijg","unit":"units_unit__jljRX","name":"units_name__LnA2G"};